<mat-card class="mx-2 my-3 mat-elevation-z6">
    <mat-card-content class="d-flex justify-content-center align-items-center">
        <mat-icon class="me-3">warning</mat-icon>
        <h3>{{message}}</h3>
    </mat-card-content>
    </mat-card>